// extracted by mini-css-extract-plugin
export var body = "body-module--body--1FUXc";